import React from 'react'
import Switch from '@material-ui/core/Switch'
import { withStyles, Theme, createStyles } from '@material-ui/core/styles'
import { FormControlLabel } from '@material-ui/core'
import { SwitchContainer } from './styles'
import { LoteSwitchProps, IosSwitchProps } from './props'

const IOSSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#24A95D',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#24A95D',
        border: '6px solid #ffff',
      },
    },
    thumb: {
      width: 23,
      height: 23,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }),
)(({ classes, ...props }: IosSwitchProps) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  )
})

const LoteSwitch: React.FC<LoteSwitchProps> = ({
  label,
  name,
  checked,
  onChange,
}: LoteSwitchProps) => (
  <SwitchContainer>
    <FormControlLabel
      control={<IOSSwitch checked={checked} onChange={onChange} name={name} />}
      labelPlacement="start"
      label={label}
    />
  </SwitchContainer>
)

LoteSwitch.defaultProps = {
  label: '',
  name: '',
  checked: false,
}

export default LoteSwitch
